module.exports = "/booking/_next/static/images/logo-allegiant-blue-6c59f21a1c23aea493a8a4cad6d0612f.svg";